/* =========================================================
   ギフトLP：ページ内ナビのクリック計測（GA4）

   ・blocks/chk-gift-anchor-item.liquid が各リンクに付ける data 属性を読み、
     GA4 へ独自イベント lp_nav_click を送る。
       nav_name      … ナビ名（例：brand_nav／category_nav）
       link_target   … 移動先のアンカーID（例：shion）
       link_label    … ボタン文言／画像の代替テキスト
       link_position … ナビの中で何番目の項目か
       link_role     … 項目の役割（main＝主ボタン／sub＝副ボタン／image＝画像リンク）
       page_path     … ページのパス
   ・gtag は snippets/chk-head.liquid の GA4 タグで定義される。
     未定義（計測タグ未読込・ブロック等）のときは何もしない。
   ・gtag('config') の再実行や dataLayer の書き換えはしないため、
     既存の GA4・広告タグの計測とは競合しない。
   ・GA4 のレポートで各パラメータを見るには、管理画面でカスタムディメンションの登録が必要。
   ・イベント委譲（document で1回だけ受ける）のため、テーマエディタで
     セクションが再読み込みされても再登録は不要。
   ========================================================= */

(function () {
  if (window.chkGiftTrackReady) return;
  window.chkGiftTrackReady = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-chk-gift-nav]');
    if (!link || typeof window.gtag !== 'function') return;

    window.gtag('event', 'lp_nav_click', {
      nav_name: link.getAttribute('data-chk-gift-nav') || '',
      link_target: link.getAttribute('data-chk-gift-nav-target') || '',
      link_label: link.getAttribute('data-chk-gift-nav-label') || '',
      link_position: Number(link.getAttribute('data-chk-gift-nav-position')) || 0,
      link_role: link.getAttribute('data-chk-gift-nav-role') || '',
      page_path: window.location.pathname
    });
  });
})();
